const PropTypes = require('prop-types');

const DynamicContent = ({ defaultContent, customContent }) => customContent || defaultContent;

module.exports = DynamicContent;
